import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import instance from "../instance"; // Your Axios instance

// Fetch Organizations
export const useFetchOrganizations = (filters) => {
  const fetchOrganizations = async () => {
    const { data } = await instance.get(`/api/orgs/all?pageNumber=${filters?.pageNumber}&pageSize=${filters?.pageSize}`); // Your API endpoint
    return data;
  };

  const query = useQuery({
    queryKey: ['fetch organizations', filters],
    queryFn: fetchOrganizations,
  });

  return query;
};

// Add Organization
export const useAddOrganization = () => {
  const queryClient = useQueryClient();
  const addOrganizationMutation = useMutation(async (newOrganization) => {
    const { data } = await instance.post('/api/orgs', newOrganization); // Your API endpoint
    return data;
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch organizations']);
    },
  });

  return addOrganizationMutation;
};

// Update Organization
export const useUpdateOrganization = () => {
  const queryClient = useQueryClient();
  const updateOrganizationMutation = useMutation(async (updatedOrganization) => {
    const { data } = await instance.put(`/api/organizations/${updatedOrganization.id}`, updatedOrganization); // Include ID
    return data;
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch organizations']);
    },
  });

  return updateOrganizationMutation;
};

// Delete Organization
export const useDeleteOrganization = () => {
  const queryClient = useQueryClient();
  const deleteOrganizationMutation = useMutation(async (organizationId) => {
    await instance.delete(`/api/orgs/${organizationId}`); // Include ID
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch organizations']);
    },
  });

  return deleteOrganizationMutation;
};